"use client";

/** Controls rollout visibility; the server independently authenticates and gates requests. */

import { AGENT_MODE_ROLLOUT_SALT, isAddressInRollout } from "@decibeltrade/utils";
import { useMemo } from "react";

import { useStatsigConfig } from "@/contexts/statsig-config-context";
import { env } from "@/env";
import { useDecibelWallet } from "@/hooks/use-decibel-wallet";

export function useAgentModeEnabled(): boolean {
  const { agentMode } = useStatsigConfig();
  const { accountAddress } = useDecibelWallet();
  const envOverride = env.NEXT_PUBLIC_ENABLE_AGENT_MODE;

  return useMemo(() => {
    if (envOverride) return true;
    return isAddressInRollout(agentMode, AGENT_MODE_ROLLOUT_SALT, accountAddress);
  }, [envOverride, agentMode, accountAddress]);
}
